import axios from "axios";
import { useEffect, useReducer } from "react";
import { dataFetchReducer } from "./utils/dataFetchReducer";
import { getConfiguration } from './utils/configuration';
import { systemCode, xs_languageCode } from '..';
import { parseAutocompleteData } from "./parseAutocompleteData";

export function useFetchAutocompleteData(isLive, shouldExecute) {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        if (!shouldExecute) {
            return;
        }

        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const url = getConfiguration().api.getAutocompleteData;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            live: isLive
        }
        fetchData(url, params, function(response) {
            const parsedData = parseAutocompleteData(response, isLive);
            dispatch({ type: 'FETCH_SUCCESS', payload: parsedData });
        });
        
        return () => {
            didCancel = true;
        };
    }, [isLive]);

    return [state, dispatch];
}
